export function navigation({ arrows = true, dots = true } = {}) {
  return function (slider) {
    let dotsEl, arrowLeft, arrowRight
    const container = slider.container
    const parent = container.parentNode

    function createDiv(className) {
      const div = document.createElement('button')
      className.split(' ').forEach((c) => div.classList.add(c))
      return div
    }

    function removeElement(el) {
      if (el && el.parentNode) el.parentNode.removeChild(el)
    }

    let arrowWrapper

    function arrowMarkup(remove) {
      if (!arrows) return

      if (remove) {
        removeElement(arrowWrapper)
        return
      }

      arrowWrapper = createDiv('arrows')

      arrowLeft = createDiv('arrow arrow--left')
      arrowLeft.addEventListener('click', () => slider.prev())

      arrowRight = createDiv('arrow arrow--right')
      arrowRight.addEventListener('click', () => slider.next())

      arrowWrapper.appendChild(arrowLeft)
      arrowWrapper.appendChild(arrowRight)

      parent.appendChild(arrowWrapper)
    }

    function dotMarkup(remove) {
      if (!dots) return

      if (remove) {
        removeElement(dotsEl)
        return
      }

      dotsEl = createDiv('dots')

      slider.track.details.slides.forEach((_, idx) => {
        const dot = createDiv('dot')
        dot.addEventListener('click', () => slider.moveToIdx(idx))
        dotsEl.appendChild(dot)
      })

      parent.appendChild(dotsEl)
    }

    function updateClasses() {
      const details = slider.track.details
      const rel = details.rel
      const slides = details.slides
      const perView = details.slidesPerView || 1

      const middleIdx = rel + Math.floor(perView / 2)

      if (arrows) {
        arrowLeft.classList.toggle('arrow--disabled', rel === 0)
        arrowRight.classList.toggle('arrow--disabled', rel === slides.length - 1)
      }

      if (dots) {
        Array.from(dotsEl.children).forEach((dot, idx) => {
          dot.classList.toggle('dot--active', idx === rel)
        })
      }

      // 👇 add this part
      slides.forEach((_, idx) => {
        const slideEl = slider.slides[idx]
        slideEl.classList.toggle('is--active', idx === middleIdx)
      })
    }

    function markup(remove) {
      arrowMarkup(remove)
      dotMarkup(remove)
    }

    slider.on('created', () => {
      markup()
      updateClasses()
    })

    slider.on('optionsChanged', () => {
      markup(true)
      markup()
      updateClasses()
    })

    slider.on('slideChanged', updateClasses)

    slider.on('destroyed', () => markup(true))
  }
}
